const AUTH0_SIGN_UP_INITIAL_SCREEN = 'signUp',
      AUTH0_LOGIN_INITIAL_SCREEN   = 'login'

export const determineAuthScreen = initialType => {
  switch (initialType) {
    case 'signup': {
      return AUTH0_SIGN_UP_INITIAL_SCREEN
    }

    case 'login': {
      return AUTH0_LOGIN_INITIAL_SCREEN
    }

    default: {
      return AUTH0_LOGIN_INITIAL_SCREEN
    }
  }
}
